import { Box, Button, Paper, Stack } from '@mui/material';
import { useRef, useState } from 'react';
import {
  CRUDComponent,
  CRUD_COMPONENT_TYPE,
  useLocalization,
  useStore,
} from '@ui-framework/index';
import { IconLibrary, FormFields } from '@product-framework/index';
import getDefaultValueByControl from '@product-framework/utils/getDefaultValueByControl';
import searchSimpleSchema from './search_simple.json';
import validationSchema from './validations';

const SERVICE_DIRECTORY_STORE_NAME = 'ServiceDirectorySearch';

function ServiceBusinessSearch({ containerProps, onSubmit, onReset }) {
  const store = useStore();
  const { formatMessage } = useLocalization();
  const formRef = useRef(null);
  const [initialValues, setInitialValues] = useState();

  const submitSearchForm = data => {
    const processedData = {
      ...data,
      ...(data?.industry?.value && { industry: data?.industry?.label }),
    };
    setInitialValues(data);
    onSubmit(processedData);
  };

  const searchProps = {
    customComponents: FormFields,
    IconLibrary,
    storeName: SERVICE_DIRECTORY_STORE_NAME,
    onSubmit: submitSearchForm,
    onClear: () => {
      store.domain.list.reset(SERVICE_DIRECTORY_STORE_NAME);
    },
    validationSchema: validationSchema(formatMessage),
    getValueByControl: getDefaultValueByControl,
  };

  const containerStyle = {
    px: 1,
    pt: 1.5,
    pb: 0.5,
    ...containerProps.sx,
  };

  return (
    <Paper {...containerProps} sx={containerStyle} elevation={0}>
      <Box
        sx={{
          '& .form-fields': {
            display: 'flex',
            verticalAlign: 'center',
          },
          '& .form-field-container': {
            width: '100%',
          },
          '& .form-field-buttons': {
            marginLeft: '1%',
            marginTop: '-4px',
            marginBottom: '5px',
          },
        }}>
        <CRUDComponent
          ref={formRef}
          type={CRUD_COMPONENT_TYPE.SEARCH_ADVANCED}
          searchProps={{
            ...searchProps,
            schema: searchSimpleSchema,
            initialValues,
            noLabels: true,
          }}>
          <Stack direction="row" spacing={1}>
            <Button
              onClick={() => formRef?.current?.submit()}
              startIcon={<IconLibrary.Submit />}
              variant="contained">
              Submit
            </Button>
            <Button
              onClick={() => {
                formRef?.current?.reset();
                onReset();
                setInitialValues({});
              }}
              startIcon={<IconLibrary.ClearSearch />}
              variant="outlined">
              Clear
            </Button>
          </Stack>
        </CRUDComponent>
      </Box>
    </Paper>
  );
}

export default ServiceBusinessSearch;
